import { render, staticRenderFns } from "./AnonymizeUserProfile.vue?vue&type=template&id=7aef06f3"
import script from "./AnonymizeUserProfile.vue?vue&type=script&lang=js"
export * from "./AnonymizeUserProfile.vue?vue&type=script&lang=js"
import style0 from "./AnonymizeUserProfile.vue?vue&type=style&index=0&id=7aef06f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports